import { render, staticRenderFns } from "./yc.vue?vue&type=template&id=5a55f0e2&scoped=true&"
import script from "./yc.vue?vue&type=script&lang=js&"
export * from "./yc.vue?vue&type=script&lang=js&"
import style0 from "./yc.vue?vue&type=style&index=0&id=5a55f0e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55f0e2",
  null
  
)

export default component.exports